// Central content constants for RNS Automobiles

export const COMPANY = {
  name: "RNS Automobiles",
  owner: "Mr. Rabindranath Saha",
  tagline: "Trusted Automobile Spare Parts Supplier",
  established: "Berhampore, West Bengal",
  address: {
    line1: "NH34, Raninagar, Chuapur",
    city: "Berhampore",
    state: "West Bengal",
    pin: "742102",
    country: "India",
  },
  phone: "+91-73650-90593",
  phoneLink: "+917365090593",
  phones: [
    { display: "+91-73650-90593", link: "+917365090593" },
    { display: "+91-96797-61512", link: "+919679761512" },
    { display: "+91-94346-39704", link: "+919434639704" },
  ],
  whatsapp: "917365090593",
  whatsapps: [
    { display: "+91-73650-90593", link: "917365090593" },
    { display: "+91-96797-61512", link: "919679761512" },
    { display: "+91-94346-39704", link: "919434639704" },
  ],
  email: "rnsautomobile.customercare@gmail.com",
  mapEmbed:
    "https://www.google.com/maps?q=RNS+Automobiles+NH34+Raninagar+Chuapur+Berhampore+West+Bengal+742102&output=embed&z=15",
  mapDirections:
    "https://www.google.com/maps/dir/?api=1&destination=RNS+Automobiles+NH34+Raninagar+Chuapur+Berhampore+West+Bengal+742102",
  mapView:
    "https://www.google.com/maps/search/?api=1&query=RNS+Automobiles+NH34+Raninagar+Chuapur+Berhampore+West+Bengal+742102",
  hours: "Wed – Mon · 10:00 AM – 7:00 PM",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Products", to: "/products" },
  { label: "Brands", to: "/brands" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

export const HERO_IMG =
  "https://images.unsplash.com/photo-1567808291548-fc3ee04dbcf0";
export const ABOUT_IMG =
  "https://images.pexels.com/photos/3807517/pexels-photo-3807517.jpeg";
export const BRANDS_BG =
  "https://images.unsplash.com/photo-1708805282785-77092a1628d3";

export const BRANDS = [
  {
    key: "mahindra",
    name: "Mahindra",
    tagline: "Rugged. Reliable. Ready.",
    description:
      "Comprehensive spare parts for Bolero, Scorpio, XUV, Thar, Pik Up and commercial range.",
    accent: "#C8102E",
  },
  {
    key: "maruti",
    name: "Maruti Suzuki",
    tagline: "India's most trusted, precisely maintained.",
    description:
      "Genuine & aftermarket components for Alto, Swift, WagonR, Baleno, Dzire, Ertiga and more.",
    accent: "#A7A9AC",
  },
  {
    key: "tata",
    name: "Tata",
    tagline: "Built to move India.",
    description:
      "Commercial vehicle spare parts only — lorries and buses. Covering Ace, 407, LPT, 1109, 1613, LPO/LPS series and other Tata heavy & light commercial ranges.",
    accent: "#FFFFFF",
  },
];

export const CATEGORIES = [
  {
    key: "engine",
    name: "Engine Parts",
    description:
      "Pistons, gaskets, valves, timing kits & core engine components.",
    image: "https://images.unsplash.com/photo-1776074396218-96c164a3ef52",
  },
  {
    key: "brake",
    name: "Brake Parts",
    description:
      "Brake pads, discs, drums, master cylinders and hydraulic hardware.",
    image: "https://images.pexels.com/photos/833320/pexels-photo-833320.jpeg",
  },
  {
    key: "suspension",
    name: "Suspension Parts",
    description:
      "Shock absorbers, struts, bushings, leaf springs & control arms.",
    image:
      "https://images.pexels.com/photos/34277923/pexels-photo-34277923.jpeg",
  },
  {
    key: "steering",
    name: "Steering Parts",
    description:
      "Rack ends, tie rods, ball joints, steering pumps and columns.",
    image: "https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7",
  },
  {
    key: "clutch",
    name: "Clutch Parts",
    description:
      "Clutch plates, pressure plates, release bearings and full kits.",
    image: "https://images.unsplash.com/photo-1613214150384-14921ff659b2",
  },
  {
    key: "filters",
    name: "Filters",
    description:
      "Oil, air, fuel and cabin filters for all major passenger models.",
    image: "https://images.unsplash.com/photo-1625047509168-a7026f36de04",
  },
  {
    key: "bearings",
    name: "Bearings",
    description:
      "Wheel, engine and transmission bearings from trusted OE suppliers.",
    image: "https://images.unsplash.com/photo-1537151377170-9c19a791bbea",
  },
  {
    key: "electrical",
    name: "Electrical Components",
    description:
      "Starters, alternators, sensors, wiring harnesses and switches.",
    image: "https://images.unsplash.com/photo-1765211003026-f7666ea3a948",
  },
  {
    key: "cooling",
    name: "Cooling System",
    description:
      "Radiators, water pumps, thermostats, hoses and coolant reservoirs.",
    image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3",
  },
  {
    key: "lubricants",
    name: "Lubricants",
    description:
      "Engine oils, gear oils, greases and coolants from reputed brands.",
    image: "https://images.unsplash.com/photo-1610647752706-3bb12232b3ab",
  },
  {
    key: "accessories",
    name: "Accessories",
    description:
      "Interior, exterior and utility accessories for daily and fleet use.",
    image: "https://images.unsplash.com/photo-1708805282785-77092a1628d3",
  },
];

export const WHY_CHOOSE = [
  { title: "Genuine Quality Parts", icon: "ShieldCheck" },
  { title: "Competitive Pricing", icon: "Tag" },
  { title: "Wide Inventory", icon: "Warehouse" },
  { title: "Experienced Staff", icon: "Users" },
  { title: "Trusted by Mechanics & Workshops", icon: "Wrench" },
  { title: "Fast Customer Support", icon: "Headphones" },
  { title: "Reliable Service", icon: "Truck" },
  { title: "Customer Satisfaction", icon: "Star" },
];

export const STATS = [
  { value: 8, suffix: "+", label: "Years of Trust" },
  { value: 7600, suffix: "+", label: "Parts in Inventory" },
  { value: 3, suffix: "", label: "Specialised Brands" },
  { value: 9600, suffix: "+", label: "Customers Served" },
];

export const FAQS = [
  {
    q: "Do you sell genuine spare parts?",
    a: "Yes. We stock genuine spare parts along with carefully selected high-quality aftermarket components sourced from trusted manufacturers.",
  },
  {
    q: "Which vehicle brands do you specialize in?",
    a: "We specialize in spare parts for Mahindra, Maruti Suzuki, and Tata vehicles.",
  },
  {
    q: "Do you have parts for both personal and commercial vehicles?",
    a: "Yes. We supply spare parts for a variety of passenger and commercial vehicles, subject to availability.",
  },
  {
    q: "Can I enquire about a part online?",
    a: "Absolutely. You can contact us through our enquiry form, WhatsApp, phone, or email, and our team will assist you in finding the correct spare part.",
  },
  {
    q: "Where is your store located?",
    a: "We are located at NH34, Raninagar, Chuapur, Berhampore, West Bengal – 742102.",
  },
  {
    q: "Do you help customers identify the correct spare part?",
    a: "Yes. Our experienced team can help you identify the appropriate spare part based on your vehicle model and requirements.",
  },
  {
    q: "Why should I choose RNS Automobiles?",
    a: "We are committed to offering quality products, competitive pricing, knowledgeable assistance, a wide inventory for Mahindra, Maruti Suzuki, and Tata vehicles, and reliable customer service you can trust.",
  },
];
